// Test IDs for the ABA app (patients, domains, actions, sessions, charts).
export const AUTH = {
	googleButton: 'auth-google-continue-button',
	submitButton: 'auth-submit-button',
};

export const PATIENTS = {
	searchInput: 'patients-search-input',
	newButton: 'new-patient-button',
	dialog: 'new-patient-dialog',
	nomeInput: 'patient-nome-input',
	cognomeInput: 'patient-cognome-input',
	diagnosiInput: 'patient-diagnosi-input',
	noteInput: 'patient-note-input',
	saveButton: 'patient-save-button',
	grid: 'patients-grid',
	emptyState: 'patients-empty-state',
};

export const PATIENT = {
	domainTabs: 'patient-domain-tabs',
	editButton: 'patient-edit-button',
	deleteButton: 'patient-delete-button',
	summaryTab: 'domain-tab-panoramica',
};

export const ACTIONS = {
	sidebar: 'actions-sidebar',
	newButton: 'new-action-button',
	dialog: 'new-action-dialog',
	nomeInput: 'action-nome-input',
	descrizioneInput: 'action-descrizione-input',
	criterioInput: 'action-criterio-input',
	saveButton: 'action-save-button',
	emptyState: 'actions-empty-state',
	descriptionTextarea: 'action-description-textarea',
	descriptionSave: 'action-description-save-button',
	statusButton: 'action-status-button',
	deleteButton: 'action-delete-button',
	exportButton: 'export-csv-button',
	printButton: 'print-chart-button',
	progress: 'action-sessions-progress',
	suggestionBanner: 'acquired-suggestion-banner',
	suggestionAccept: 'acquired-suggestion-accept-button',
};

export const SESSIONS = {
	addButton: 'add-session-button',
	dialog: 'add-session-dialog',
	corretteInput: 'session-corrette-input',
	totaleInput: 'session-totale-input',
	noteInput: 'session-note-input',
	dateButton: 'session-date-button',
	submitButton: 'add-session-submit-button',
	table: 'sessions-table',
};

export const CHART = {
	container: 'aba-chart-container',
	modePercent: 'chart-mode-percent',
	modeCount: 'chart-mode-count',
};
